export const NEXT_BUTTON_TEXT = 'Next'
export const PREVIOUS_BUTTON_TEXT = 'Previous'
export const SortOrder = {
  asc: 'asc',
  desc: 'desc',
}
